import React from "react";
import "./SelectableCard.css";

interface SelectableCardProps {
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
}

const SelectableCard: React.FC<SelectableCardProps> = ({ title, description, isSelected, onClick, className = "" }) => {
  return (
    <button
      type="button"
      className={`selectable-card ${isSelected ? "selectable-card--selected" : ""} ${className}`}
      onClick={onClick}
    >
      <div className="selectable-card-content">
        <p className="selectable-card-title">{title}</p>
        {description && <p className="selectable-card-description">{description}</p>}
      </div>
    </button>
  );
};

export default SelectableCard;
